export const common = {
  // Navigation
  home: 'Home',
  financing: 'Financing',
  inventory: 'Inventory',
  rentals: 'Rentals',
  contact: 'Contact',
  
  // Hero Section
  heroTitle: 'Quality Commercial Vehicles for Your Business',
  heroSubtitle: 'From box trucks to cargo vans, find the perfect vehicle to grow your business. Trade-ins, rentals, and flexible financing available.',
  viewInventory: 'View Inventory',
  rentalOptions: 'Rental Options',
  getFinancing: 'Get Financing',
  
  // Services
  servicesTitle: 'Our Services',
  servicesSubtitle: 'Complete commercial vehicle solutions for your business needs',
  vehicleSales: 'Vehicle Sales',
  vehicleSalesDesc: 'Quality used commercial trucks and cargo vans with detailed inspections',
  tradeIns: 'Trade-Ins',
  tradeInsDesc: 'Fair market value for your current vehicle with instant appraisals',
  rentalsService: 'Rentals',
  rentalsServiceDesc: 'Short-term and long-term rental options for temporary needs',
  financingService: 'Financing',
  financingServiceDesc: 'Flexible financing solutions with competitive rates and terms',
  
  // Featured Vehicles
  featuredVehicles: 'Featured Vehicles',
  featuredVehiclesDesc: 'Quality commercial vehicles ready for your business',
  manageInventory: 'Manage Inventory',
  allVehicles: 'All Vehicles',
  boxTrucks: 'Box Trucks',
  cargoVans: 'Cargo Vans',
  reeferTrucks: 'Reefer Trucks',
  tailgateTrucks: 'Tailgate Trucks',
  rampTrucks: 'Ramp Trucks',
  viewDetails: 'View Details',
  viewAllInventory: 'View All Inventory',
  
  // Rental Section
  flexibleRentals: 'Flexible Rental Options',
  flexibleRentalsDesc: 'Choose the rental plan that fits your business needs',
  dailyRentals: 'Daily Rentals',
  dailyRentalsDesc: 'Perfect for short-term projects and urgent deliveries',
  weeklyRentals: 'Weekly Rentals',
  weeklyRentalsDesc: 'Ideal for short-term projects and seasonal demands',
  monthlyRentals: 'Monthly Rentals',
  monthlyRentalsDesc: 'Best value for ongoing business operations',
  mostPopular: 'Most Popular',
  bookDailyRental: 'Book Daily Rental',
  bookWeeklyRental: 'Book Weekly Rental',
  bookMonthlyRental: 'Book Monthly Rental',
  customQuote: 'Need a custom rental solution? We offer flexible terms for unique business requirements.',
  contactCustomQuote: 'Contact for Custom Quote',
  
  // Features
  comprehensiveInsurance: 'Comprehensive insurance',
  unlimitedKilometers: 'Unlimited kilometers',
  fullFleetOptions: 'Full fleet options',
  maintenanceIncluded: 'Maintenance included',
  fleetManagementSupport: 'Fleet management support',
  flexibleTerms: 'Flexible terms',
  
  // Why Choose Us
  whyChooseUs: 'Why Choose Us',
  whyChooseUsDesc: 'Your trusted partner for commercial vehicle solutions',
  qualityGuaranteed: 'Quality Guaranteed',
  qualityGuaranteedDesc: 'Every vehicle undergoes thorough inspection and comes with our quality guarantee',
  expertSupport: 'Expert Support',
  expertSupportDesc: 'Our experienced team provides personalized service and ongoing support',
  competitivePricing: 'Competitive Pricing',
  competitivePricingDesc: 'Fair, transparent pricing with flexible financing options to fit your budget',
  
  // CTA Section
  readyToFind: 'Ready to Find Your Next Commercial Vehicle?',
  readyToFindDesc: 'Contact us today to discuss your business needs and explore our inventory',
  browseInventory: 'Browse Inventory',
  scheduleAppointment: 'Schedule Appointment',
  
  // Footer
  footerDesc: 'Your trusted partner for quality commercial vehicles, trades, rentals, and financing solutions.',
  services: 'Services',
  contactInfo: 'Contact Info',
  allRightsReserved: 'All rights reserved.',
  websiteBuilder: 'Website Builder',
  
  // Common Actions
  loading: 'Loading...',
  loadingVehicles: 'Loading vehicles...',
  
  // Contact Info
  phone: '514.571.7256',
  email: 'camionjma@gmail.com',
  address: '368 rang du brulee\ncontre coeur QC\nCanada'
};